// RoleRowAction.jsx
import React from "react";
import { Edit, Trash2 } from "lucide-react";
import { deleteRole } from "../../../api/settings/roleManager";
import { showSuccessToast, showErrorToast } from "../../../components/ConfirmDialog";
import { confirmDelete, DELETE_ENTITY } from "../../../utils/confirmDelete";

const RowAction = ({ data, onEdit, onDeleted }) => {
  const handleDelete = async () => {
    const confirm = await confirmDelete({
      type: DELETE_ENTITY.role,
      name: data?.name || data?.role_name,
    });

    if (confirm.isConfirmed) {
      try {
        await deleteRole(data.id); // ✅ dùng id thay vì code
        showSuccessToast("Đã xóa thành công");
        onDeleted?.(); // gọi lại hàm reload dữ liệu
      } catch (err) {
        console.error("Delete role error:", err);
        showErrorToast("Lỗi khi xóa vai trò");
      }
    }
  };

  return (
    <div className="flex gap-2">
      <button onClick={onEdit}>
        <Edit size={18} className="text-yellow-600" />
      </button>
      <button onClick={handleDelete}>
        <Trash2 size={18} className="text-red-600" />
      </button>
    </div>
  );
};

export default RowAction;
